import { useEffect } from "react";
import { useMyStore } from "store";

// Built from chat-widget/ into public/onechat/v1/ (see chat-widget/README.md).
const LOADER_SRC = "/onechat/v1/loader.js";
const LOADER_ID = "onechat-loader";
// Kill switch, set per environment in .env*: anything but "true" embeds nothing.
const ENABLED = process.env.REACT_APP_ONECHAT_ENABLED === "true";

declare global {
  interface Window {
    OneChatConfig?: Record<string, unknown> & { tenantId: string };
    OneChat?: {
      open: (options?: { message?: string }) => void;
      close: () => void;
      toggle: () => void;
    };
  }
}

/** Embeds the 1chat support widget once the bootstrap config has the API domain. */
export const useOneChat = () => {
  const apiDomain = useMyStore((s) => s.bootstrap?.apiDomain);

  useEffect(() => {
    if (!ENABLED || !apiDomain || document.getElementById(LOADER_ID)) return;

    window.OneChatConfig = {
      tenantId: process.env.REACT_APP_NAU_TENANT_ID || "",
      apiDomain,
      title: "CSKH WinAZ",
      subtitle: "Hỗ trợ 24/7",
      greeting: "Chào bạn 👋 WinAZ có thể giúp gì cho bạn?",
      // 1chat's public upload host (its VITE_STATIC_URL) for this environment.
      mediaBaseUrl: process.env.REACT_APP_ONECHAT_MEDIA_URL || undefined,
    };

    const script = document.createElement("script");
    script.id = LOADER_ID;
    script.src = LOADER_SRC;
    script.async = true;
    document.body.appendChild(script);
  }, [apiDomain]);
};
